import { format, subMonths, subYears } from "date-fns";
import { TFunction } from "i18next";
import { useMemo } from "react";

/**
 * テーブルのカラムを生成するカスタムフック
 *
 * @param latestYM 最新の年月
 * @param displayPeriods 表示する期間数
 * @param t 翻訳関数
 * @param isYearlyView 年次表示フラグ
 * @returns カラム名の配列
 */
export function useTableColumns(
  latestYM: Date,
  displayPeriods: number,
  t: TFunction,
  isYearlyView: boolean = false,
) {
  return useMemo(() => [
    t("bi.table.category"),
    ...Array.from({ length: displayPeriods }, (_, i) => i)
      .map((i) => {
        if (isYearlyView) {
          return format(subYears(latestYM, i), t("bi.table.yearFormat"));
        } else {
          return format(subMonths(latestYM, i), t("bi.table.monthFormat"));
        }
      })
      .toReversed(),
    isYearlyView ? t("bi.table.yearlyComparison") : t("bi.table.monthlyComparison"),
  ], [latestYM, displayPeriods, t, isYearlyView]);
}
